




import Vue from "vue"
import PSignupPage from "~/components/custom/signup/PSignupPage.vue"
import { makeAuthPagePath } from "~/uiLogics/auth/authExecutor"

export default Vue.extend({
  components: {
    PSignupPage,
  },
  layout: "auth",
  data() {
    return {
      show: false,
    }
  },
  head(): object {
    return this.$clHelpers.metaTag.generate({
      title: "新規登録",
      currentPath: this.$nuxt.$route.path,
    })
  },
  beforeMount() {
    if (this.$clAuth.tryingToLogin) {
      const path = makeAuthPagePath({ route: this.$route })
      this.$nuxt.$router.push({ path })
      return
    } else if (!this.$clAuth.finishedAuthProcess) {
      this.$clAuth.completeAuthProcess()
    }
    this.show = true
  },
})
